import { useState } from "react";

import BaseCard from "../../../../../components/ui/BaseCard";

import AddLanguagesModal from "../../../components/AddLanguagesModal";
import { useMutation, useQuery } from "@tanstack/react-query";
import { deleteUserLanguage, fetchAllUserLanguages } from "../../../../../services/api/language";
import { getLanguageLabel } from "../../../../../utils/helpers";

const AddLanguage = () => {
  const [isAddLanguageModalOpen, setIsAddLanguageModalOpen] = useState(false);
  const {
    isPending: isLanguagesLoading,
    error: isLanguagesError,
    data: languagesData,
    refetch: refetchAllUserLanguages,
  } = useQuery({
    queryKey: ["languages"],
    queryFn: () => fetchAllUserLanguages(),
  });

  const {
    isPending: isDeletedLanguageApiLoading,
    error: isDeletedLanguageApiError,
    data: deletedLanguageData,
    mutateAsync: deleteUserLanguageMutation,
  } = useMutation({
    mutationFn: deleteUserLanguage,
    enabled: false,
  });

  const handleDeleteLanguage = async (id) => {
    try {
      await deleteUserLanguageMutation(id);
      refetchAllUserLanguages();
    } catch (error) {}
  };

  return (
    <form>
      <BaseCard className="py-3 px-4 mt-3 border rounded-lg shadow-sm" elevation={0}>
        <div className="bg-light rounded-sm py-2 px-4 mb-4 flex items-center justify-between">
          <p className="text-base font-normal">Language</p>
          <i
            className="fa-solid fa-circle-plus cursor-pointer text-secondary text-xl"
            onClick={() => setIsAddLanguageModalOpen(true)}
          ></i>
        </div>

        <div className="flex flex-wrap gap-4">
          {languagesData?.data?.map((language) => (
            <div className="px-4 py-1 bg-light rounded-sm flex items-center">
              <p className="lowercase">
                {getLanguageLabel(language?.language)} - {language?.proficiency}
              </p>
              <i
                className="fa-solid fa-xmark ml-2 cursor-pointer hover:text-blue-500"
                onClick={() => handleDeleteLanguage(language.id)}
              ></i>
            </div>
          ))}
        </div>
      </BaseCard>
      {isAddLanguageModalOpen && (
        <AddLanguagesModal
          open={isAddLanguageModalOpen}
          close={setIsAddLanguageModalOpen}
          refetchAllUserLanguages={refetchAllUserLanguages}
          languagesData={languagesData}
        />
      )}
    </form>
  );
};

export default AddLanguage;
